import { render } from "./Home.vue?vue&type=template&id=77f08f5c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script